import React, { useContext, useEffect, useId, useState } from 'react';
import { SetInnerHTML } from '../../../../../UI/SetInnerHTML/SetInnerHTML';
import DatePicker from 'react-datepicker';
import { SharedProductDisplayEcard } from '../../../../Shared/Content/ProductDetail/ProductDisplayEcard/ProductDisplayEcard';
import { CloseXIcon } from '../../../../../UI/Icons/Icons';

import '../../../../../../styles/master/plugins/_date-picker.scss';
import Swiper from '../../../../../Swiper/Swiper';
import { SwiperSlide } from 'swiper/react';
import useSwiperHelpers from '../../../../../Swiper/useSwiperHelpers';
import { AppContext } from '../../../../../../contexts/AppContext';

function Slider({ items, onChange, ...props }) {
  const spaceBetween = 10;
  const slidesPerView = 3;
  const { id, slideClass, style } = useSwiperHelpers({ spaceBetween, slidesPerView });

  const { passedAppFunctions } = useContext(AppContext);

  return (
    <div
      style={{
        margin: '0 25px',
      }}
    >
      <style>{style}</style>
      <Swiper
        id={id}
        direction={'horizontal'}
        allowTouchMove
        centeredSlides
        loop
        navigation={{
          enabled: passedAppFunctions.siteFormat === 'desktop',
        }}
        slideToClickedSlide
        pagination={{
          enabled: true,
          clickable: true,
        }}
        slidesPerView={slidesPerView}
        spaceBetween={spaceBetween}
        onSlideChange={(swiper) => {
          onChange && onChange(swiper.realIndex);
        }}
        {...props}
      >
        {items.map((item, i) => (
          <SwiperSlide key={item.imageName} className={`${slideClass} swiper-scale-active`}>
            <figure>
              <img
                alt={item.imageDescription}
                src={`//dimg.dillards.com/is/image/DillardsZoom/nav2/eGift-Card/ecard_${item.imageName}.jpg`}
              />
            </figure>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export class ProductDisplayEcard extends SharedProductDisplayEcard {
  render() {
    return (
      <section className='row' id='ProductDisplayEcard'>
        <div className='col-sm-12'>
          <Slider
            onSwiper={(swiper) => (this.slider = swiper)}
            items={this.props.contentData.ecardImages}
            onChange={(index) => {
              this.setState((prevState) => ({
                formData: {
                  ...prevState.formData,
                  selectedImage: {
                    ...prevState.formData.selectedImage,
                    value: index,
                  },
                },
              }));
            }}
          />
        </div>
        <div className='col-sm-12'>
          <h1>{this.props.contentData.originalProductName}</h1>
          <div>
            <p className='reqMessage'>* Indicates a required field</p>
          </div>
          {this.props.contentData.isInternational == 'Y' || !this.props.passedAppFunctions.isInternational() ? (
            <React.Fragment>
              <div className='row d-flex align-items-stretch'>
                <div className='col-md-12 col-lg-4 div--eGiftCardInputs'>
                  <div className='form-group required'>
                    <label className='sr-only' htmlFor='type-of-card'>
                      Type of Card &#40;required&#41;
                    </label>
                    <select
                      className={
                        !this.state.formData.selectedImage.valid
                          ? 'invalid form-control required'
                          : 'form-control required'
                      }
                      id='type-of-card'
                      value={
                        this.state.formData.selectedImage.value === undefined
                          ? '*'
                          : this.state.formData.selectedImage.value
                      }
                      onChange={(e) => {
                        this.imageOnChange(e);
                        this.handleInputBlur(e, 'selectedImage', true);
                      }}
                      required
                    >
                      <option disabled='disabled' value='*'>
                        Type of Card*
                      </option>
                      {this.props.contentData.ecardImages.map((thisImg, index) => (
                        <option key={thisImg.imageName} value={index}>
                          {thisImg.imageDescription}
                        </option>
                      ))}
                    </select>
                    {!this.state.formData.selectedImage.valid ? (
                      <span className='error-tip' role='alert'>
                        Please select a card
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='form-group required'>
                    <label className='sr-only' htmlFor='amount-select'>
                      Amount &#40;required&#41;
                    </label>
                    <select
                      className={
                        !this.state.formData.selectedAttrVal.valid
                          ? 'invalid form-control required'
                          : 'form-control required'
                      }
                      id='amount-select'
                      value={this.state.formData.selectedAttrVal.value}
                      onChange={(e) => {
                        this.amountOnChange(e);
                        this.handleInputBlur(e, 'selectedAttrVal', true);
                      }}
                      required
                    >
                      <option disabled='disabled' value='*'>
                        Amount*
                      </option>
                      {this.props.contentData.attributes[0]?.values.map((thisAttrVal) => (
                        <option key={thisAttrVal.value} value={thisAttrVal.value}>
                          {thisAttrVal.name}
                        </option>
                      ))}
                    </select>
                    {!this.state.formData.selectedAttrVal.valid ? (
                      <span className='error-tip' role='alert'>
                        Please select valid amount
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='form-group required'>
                    <label className='sr-only' htmlFor='recip-name'>
                      Recipient&apos;s Name &#40;required&#41;
                    </label>
                    <input
                      className={!this.state.formData['recipName'].valid ? 'invalid form-control' : 'form-control'}
                      type='text'
                      id='recip-name'
                      data-inputname='recipName'
                      value={this.state.formData['recipName'].value}
                      onChange={(e) => {
                        this.updateFormInput(e, 'recipName');
                        this.handleInputBlur(e, 'recipName', true);
                      }}
                      maxLength='20'
                      placeholder="Recipient's Name*"
                      required
                    />
                    {!this.state.formData['recipName'].valid ? (
                      <span className='error-tip' role='alert'>
                        Please enter the recipient&apos;s name.
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
                <div className='col-sm-12 col-lg-4 div--eGiftCardInputs'>
                  <div className='form-group required'>
                    <label className='sr-only' htmlFor='recip-email'>
                      Send-to Email &#40;required&#41;
                    </label>
                    <input
                      className={!this.state.formData['recipEmail'].valid ? 'invalid form-control' : 'form-control'}
                      type='email'
                      id='recip-email'
                      data-inputname='recipEmail'
                      value={this.state.formData['recipEmail'].value}
                      onChange={(e) => {
                        this.updateFormInput(e, 'recipEmail');
                        this.handleInputBlur(e, 'recipEmail', true);
                      }}
                      placeholder='Send-to Email*'
                      required
                    />
                    {!this.state.formData['recipEmail'].valid ? (
                      <span className='error-tip' role='alert'>
                        Please enter the recipient&apos;s email.
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='form-group required'>
                    <label className='sr-only' htmlFor='recip-email-confirm'>
                      Confirm Send-to Email &#40;required&#41;
                    </label>
                    <input
                      className={
                        !this.state.formData['recipEmailConfirm'].valid ? 'invalid form-control' : 'form-control'
                      }
                      type='email'
                      id='recip-email-confirm'
                      data-inputname='recipEmailConfirm'
                      value={this.state.formData['recipEmailConfirm'].value}
                      onChange={(e) => {
                        this.updateFormInput(e, 'recipEmailConfirm');
                        this.handleInputBlur(e, 'recipEmailConfirm', true);
                      }}
                      placeholder='Confirm Send-to Email*'
                      required
                    />
                    {!this.state.formData['recipEmailConfirm'].valid ? (
                      <span className='error-tip' role='alert'>
                        Please confirm the recipient&apos;s email.
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='form-group'>
                    <label className='sr-only' htmlFor='send-date'>
                      Send Date &#40;required&#41;
                    </label>
                    <div>
                      <DatePicker
                        selected={this.state.sendDate}
                        onChange={(e) => {
                          this.handleDateChange(e);
                        }}
                        minDate={new Date()}
                        maxDate={new Date(new Date().setFullYear(new Date().getFullYear() + 1))}
                        popperPlacement='top'
                        id='send-date'
                        nextMonthButtonLabel=''
                        excludeDates={[new Date('December 25, ' + new Date().getFullYear() + ' 00:00:01')]}
                        previousMonthButtonLabel=''
                        placeholderText={'Send Date*'}
                        className={!this.state.formData.date.valid ? 'invalid form-control required' : 'form-control'}
                        required
                      />
                    </div>
                    {!this.state.formData.date.valid ? (
                      <span className='error-tip' role='alert'>
                        Please enter a valid date within 1 year of today&apos;s date.
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
                <div className='col-sm-12 col-lg-4 div--eGiftCardInputs'>
                  <div className='form-group required'>
                    <label className='sr-only' htmlFor='sender-name'>
                      Your Name &#40;required&#41;
                    </label>
                    <input
                      className={!this.state.formData['senderName'].valid ? 'invalid form-control' : 'form-control'}
                      type='text'
                      id='sender-name'
                      data-inputname='senderName'
                      value={this.state.formData['senderName'].value}
                      onChange={(e) => {
                        this.updateFormInput(e, 'senderName');
                        this.handleInputBlur(e, 'senderName', true);
                      }}
                      maxLength='20'
                      placeholder='Your Name*'
                      required
                    />
                    {!this.state.formData['senderName'].valid ? (
                      <span className='error-tip' role='alert'>
                        Please enter your name.
                      </span>
                    ) : (
                      ''
                    )}
                  </div>
                  <div className='form-group'>
                    <label className='sr-only' htmlFor='sender-comments'></label>
                    <textarea
                      className='form-control'
                      type='text'
                      id='sender-comments'
                      rows='6'
                      columns='46'
                      maxLength='120'
                      data-inputname='senderMessage'
                      value={this.state.formData['senderMessage'].value}
                      onChange={(e) => {
                        this.updateFormInput(e, 'senderMessage');
                        this.handleInputBlur(e, 'senderMessage', false);
                      }}
                      placeholder='Personal Comments (optional)'
                    />
                    <span className='charCount'>
                      {120 - this.state.formData['senderMessage'].value.length + ' characters remaining'}
                    </span>
                  </div>
                </div>
              </div>
              <div className='row justify-content-end'>
                <div className='col-8'>
                  {this.state.errorMessage && (
                    <div className='wishListMessage alert'>
                      <button
                        className='close closeWishListAlertMessage btn-tertiary'
                        onClick={this.closeErrorMessage}
                        type='button'
                      >
                        <CloseXIcon />
                      </button>
                      {this.state.errorMessage}
                    </div>
                  )}
                </div>
                <div className='col-4'>
                  <button
                    className='btn btn-primary btn-block div--eGiftCardATB'
                    role='button'
                    id='add-to-bag'
                    type='button'
                    onClick={this.ajaxAddToBag}
                  >
                    Add To Bag
                  </button>
                </div>
              </div>
              <div className='col-sm-12 eGiftCardDescription'>
                <label>Description:</label>
                <SetInnerHTML innerHTML={this.props.contentData.longDescription} />
              </div>
            </React.Fragment>
          ) : (
            <div id='error-message' className='alert alert-danger' role='alert'>
              This item is not available for international purchase.
            </div>
          )}
        </div>
      </section>
    );
  }
}

export default ProductDisplayEcard;
